import styled from 'styled-components';
import {IoReloadOutline} from 'react-icons/io5';
import Spinner from 'react-spinners/ClipLoader';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Title = styled.h3`
  font-size: 22px;
  margin: 0;
  color: ${(props) => props.theme.colors.text};
`;

export const Reload = styled(IoReloadOutline)`
  font-size: 22px;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const Description = styled.p`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text};

  time {
    font-size: 12px;
  }
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const Loader = styled(Spinner).attrs((props) => ({
  size: 18,
  color: props.theme.colors.primary,
}))``;

export const BackIconContainer = styled.div`
  cursor: pointer;
  margin-top: 6px;
`;
